// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xsbE","title":"Info_title__2Iioy","links":"Info_links__Qm1uP","link":"Info_link__2J01m","logo":"Info_logo__288Y9"};